import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {AppState} from "../state/AppStore";
import {HomepageView} from "./HomepageView";
import {AppView} from "../state/MetaSlice";
import {UnknownView} from "./UnknownView";
import {NotAuthorizedView} from "./NotAuthorizedView";
import {LoadingView} from "./LoadingView";
import "./AppViews.css";
import {lockTab} from "../utility/tabLock";
import {SorryView} from "./SorryView";

export const AppViews = () => {
    const [user, meta] = useSelector((state: AppState) => [state.user, state.meta]);
    const [tabLock, setTabLock] = useState(false);

    useEffect(() => {
        const didLockTab = lockTab();
        setTabLock(!didLockTab);
    }, []);

    let classes = ["AppViews"];

    // Figure out what to show
    let view = (<></>);
    if (!meta.ready) {
        view = (<LoadingView/>);
    } else if (tabLock) {
        view = (<SorryView/>);
    } else if (!user.authorized) {
        view = (<NotAuthorizedView/>);
    } else {
        switch (meta.view) {
            case AppView.Homepage:
                view = (<HomepageView/>);
                break;
            default:
                view = (<UnknownView/>)
                break;
        }
    }

    // Any error?
    let errorView = <></>;
    if (meta.error) {
        classes.push("feature--error");
        errorView = (
            <div className="AppViews--error">{meta.error}</div>
        );
    }

    return (
        <div className={classes.join(" ")}>
            <div className="AppViews--container">
                {view}
            </div>
            {errorView}
            <div className="AppViews--captcha">
                This site is protected by reCAPTCHA and the Google
                &nbsp;
                <a href="https://policies.google.com/privacy">Privacy Policy</a>
                &nbsp;
                and
                &nbsp;
                <a href="https://policies.google.com/terms">Terms of Service</a> apply.
            </div>
        </div>
    );
};
